(() => {
  const findGrid = (sectionId) =>
    Array.from(document.querySelectorAll('[data-b2b-product-grid]')).find((grid) => grid.dataset.sectionId === sectionId);

  const setupToolbar = (toolbar) => {
    if (toolbar.dataset.b2bInitialized === 'true') return;

    const sectionId = toolbar.dataset.b2bCollectionToolbar;
    if (!toolbar) return;

    const densityButtons = toolbar.querySelectorAll('[data-b2b-density]');
    const searchInput = toolbar.querySelector('[data-b2b-visible-search]');
    const resetButton = toolbar.querySelector('[data-b2b-visible-search-reset]');
    const storageKey = `b2b-density-${sectionId}`;
    let currentDensity = 'comfortable';

    const applyDensity = (density) => {
      const grid = findGrid(sectionId);
      if (!grid) return;
      currentDensity = density;

      grid.classList.toggle('is-compact', density === 'compact');
      grid.classList.toggle('is-list', density === 'list');
      densityButtons.forEach((button) => {
        button.classList.toggle('is-active', button.dataset.b2bDensity === density);
      });
      try {
        window.localStorage.setItem(storageKey, density);
      } catch (error) {
        // Ignore private browsing storage failures.
      }
    };

    const filterVisibleProducts = () => {
      const grid = findGrid(sectionId);
      if (!grid) return;

      const query = (searchInput?.value || '').trim().toLowerCase();
      grid.classList.toggle('is-filtering', Boolean(query));

      grid.querySelectorAll('.grid__item').forEach((item) => {
        const title = item.querySelector('.card__heading a')?.textContent || '';
        item.classList.toggle('is-hidden-by-query', Boolean(query) && !title.toLowerCase().includes(query));
      });
    };

    densityButtons.forEach((button) => {
      button.addEventListener('click', () => applyDensity(button.dataset.b2bDensity));
    });

    searchInput?.addEventListener('input', filterVisibleProducts);
    resetButton?.addEventListener('click', () => {
      if (!searchInput) return;
      searchInput.value = '';
      filterVisibleProducts();
      searchInput.focus();
    });

    try {
      currentDensity = window.localStorage.getItem(storageKey) || currentDensity;
    } catch (error) {
      // Ignore private browsing storage failures.
    }
    applyDensity(currentDensity);

    const productGridContainer = document.getElementById('ProductGridContainer');
    if (productGridContainer) {
      new MutationObserver(() => {
        applyDensity(currentDensity);
        filterVisibleProducts();
      }).observe(productGridContainer, { childList: true, subtree: true });
    }

    toolbar.dataset.b2bInitialized = 'true';
  };

  document.querySelectorAll('[data-b2b-collection-toolbar]').forEach(setupToolbar);
})();
